import { FeatureDTO } from "./FeatureDTO";

export class GamificationFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
